import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  .header-text {
    padding-top: ${SPACERS.medium};
    padding-bottom: ${SPACERS.medium};
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: ${COLORS.grayDarkest};
    background-color: ${COLORS.grayLightest};
    border-bottom: 2px solid ${COLORS.grayLight};
  }
  .metric-header {
    padding-left: ${SPACERS.large};
  }
  .stage-header {
    text-align: center;
  }
  .results-header {
    padding-left: ${SPACERS.small};
    padding-right: ${SPACERS.small};
    border-left: 1px solid ${COLORS.grayLight};
  }
`;

const ImpactTableHeaders: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <StyledDiv className={className}>
      <TrueImpactText
        variant="body-bold"
        className="header-text stage-header top-left-radius"
      >
        Stage
      </TrueImpactText>
      <TrueImpactText variant="body-bold" className="header-text metric-header">
        Metric
      </TrueImpactText>
      <TrueImpactText
        variant="body-bold"
        className="header-text results-header top-right-radius"
      >
        Results
      </TrueImpactText>
    </StyledDiv>
  );
};

export default React.memo(ImpactTableHeaders);
